import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/debounceTime';

import { actionIs } from '../../utils';
import { ToggleFavouriteButtonAppState } from './models';
import { toggleFavouriteButton } from './actions';
import merge from 'lodash/merge';
import each from 'lodash/each';
import {
  getClientLocale,
  I18NProvider
} from "@utils/i18n";
import ToastContainer from "@components/ToastContainer";
import { ProductFavoritesToggleContainer } from '@containers/ProductFavoritesToggle';
import apolloWrapper from '@hoc/apolloWrapper';

const ProductFavoritesToggle = apolloWrapper(ProductFavoritesToggleContainer);

let rootsList = [];

export function reindexFavourite() {
    each(rootsList, ({ root }) => {
      root.unmount();
    });

    rootsList = Array.from(document.querySelectorAll('.b-tile-item__favorite-inner'))
      .map((container) => ({
        root: createRoot(container),
        container,
      }));

    if (rootsList.length) {
        let defaultInitialState = new ToggleFavouriteButtonAppState(window, document).getState();

        each(rootsList, ({ root, container }) => {
            let eventStream = new Subject();
            let initialState = {...defaultInitialState};

            if (container.dataset) {
                merge(initialState, container.dataset);
            }

            let fs = [
                eventStream
                    .filter(actionIs('toggleFavouriteButton'))
                    .debounceTime(200)
                    .map(toggleFavouriteButton),
            ];

            Observable
                .merge(...fs)
                .scan((state, action) => action(state), initialState)
                .startWith(initialState)
                .subscribe(
                    function (state) {
                      const { lang, routerBasename } = getClientLocale();
                      root.render(
                        <BrowserRouter basename={routerBasename}>
                          <I18NProvider lang={lang}>
                            {
                              () => (
                                <>
                                  <ToastContainer />
                                  <ProductFavoritesToggle
                                    product={{
                                      id: Number(state.productId),
                                      name: state.productName,
                                      price: state.productPrice,
                                      breadcrumbs: state.productBreadcrumbs,
                                      likes: state.favouriteCounter,
                                      isLiked: String(state.isLiked).toLowerCase() === 'true',
                                      catalog: state.productCatalogSlug
                                        ? { slug: state.productCatalogSlug }
                                        : undefined,
                                      brand: state.productBrandName
                                        ? { name: state.productBrandName }
                                        : undefined
                                    }}
                                    type="Product"
                                    onChange={() => {
                                      eventStream.next({
                                        action: 'toggleFavouriteButton',
                                      })
                                    }}
                                  />
                                </>
                              )
                            }
                          </I18NProvider>
                        </BrowserRouter>)
                    }
                );
        });
    }
}
